/* eslint-disable  */
import React, { useEffect, useState, useRef } from 'react';
import {
  DataGrid,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
} from '@mui/x-data-grid';
import ButtonGroup from '@material-ui/core/ButtonGroup';

import dayjs from 'dayjs';
import { Tooltip } from '@mui/material';

import useBoletimContext from 'context/BoletimContext';
import { Button, makeStyles } from '@material-ui/core';
import ScheduleIcon from '@material-ui/icons/Schedule';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import theme from 'styles/theme';
import { green, orange, red } from '@material-ui/core/colors';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { TextFieldProps } from '@mui/material';
import { IGridDaily } from './types';
import Loading from 'components/atoms/Loading';
import SnackBarMessages from 'components/atoms/Snackbar';

const NewDailyBulletinPlanningGrid = ({
  data,
  params,
  toggleState,
  isLoading,
}: IGridDaily) => {
  const resultData = data;
  const resultDataPush = data;

  for (let k = 0; k < params[0].activitiesId?.length; k += 1) {
    // filtro atividade //
    const resultFilterActivity = resultData.filter(
      result => result.activitiesId === params[0].activitiesId[k],
    );
    for (let j = 0; j < params[0].equipmentId?.length; j += 1) {
      //  filtro equipment //
      const resultFilterEquipment = resultFilterActivity.filter(
        resultEqp => resultEqp.equipmentId === params[0].equipmentId[j],
      );

      if (resultFilterEquipment.length < 1) {
        resultDataPush.push({
          activityName: params[0].activityName[k],
          activityPlanId: params[0].activityPlanId[k],
          bulletinFlag: params[0].bulletinFlag[k],
          bulletinStatus: params[0].bulletinFlag[k],
          completionPercentage: params[0].completionPercentage,
          id: Math.floor(Math.random() * 9000),
          tipo: toggleState,
          observationField: params[0].observationField[k],
          providerName: params[0].providerName,
          activity: params[0].activity[k],
          activitiesId: params[0].activitiesId[k],
          clusterId: params[0].clusterId[0],
          installationId: params[0].installationId
            ? params[0].installationId
            : params[0].installationId[k],
          instalationId: +params[0].instalationId[k],
          executor: params[0].executor[k],
          maintenanceType: params[0]?.maintenanceType,
          maintenance: params[0].maintenance[k],
          equipmentId: params[0].equipmentId[j],
          startPrevBr: params[0].startPrevBr,
          completionPrev: params[0].completionPrev,
          endPrevBr: params[0].endPrevBr,
          equipmentTag: params[0]?.equipmentTag[j],
          equipment: params[0].equipment[j],
          durationPrev: params[0].durationPrev,
          outage: params[0].outage,
          utilization: params[0].utilization,
          week: params[0].week,
          planNumber: params[0].planNumber,
          endReplanBr: params[0].endReplanBr,
          startReplanBr: params[0].startReplanBr,
          area: params[0]?.area,
          activityDescription: params[0].activityDescription,
        });
      }
    }
  }

  // verificar se precisa do status //

  const useStyles = makeStyles({
    container: {
      '& .makeStyles-container-334': {
        maxHeight: 0,
      },
      marginBottom: '15px',

      '& MuiDataGrid-root': {
        border: 'none',
      },
      '& .MuiDataGrid-virtualScrollerRenderZone': {
        height: '600px',
        overflowY: 'auto !important',
        minHeight: '87px',
      },
      '& .MuiDataGrid-virtualScroller': {
        width: '644px',
        minHeight: '75px',
        maxHeight: '601px  !important',
      },
      display: 'flex',
      flexWrap: 'wrap',

      '& .laranja': {
        backgroundColor: orange[50] + ' !important',
      },
    },

    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    gridHeader: {
      display: 'flex',
      margin: '15px 40px 0 0',
    },
    h2: {
      color: 'rgb(88, 147, 241)',
      display: 'inline-block',
      fontSize: '1.15rem',
      marginBottom: '8px',
      marginRight: '12px',
      marginTop: '13px',
    },
    button: { width: '20px' },
    buttonGroup: {
      margin: '8px 4px',
      '& .MuiButton-label': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
      },
    },
    singleButton: {
      margin: '8px 4px',
      padding: '5px',
    },

    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
      border: '1px solid #000000c8',
      borderRadius: 6,
      fontSize: '12px',

      '& .MuiInputLabel-animated': {
        margin: '4px',
      },
      '& label + .MuiInput-formControl': {
        marginLeft: '4px',
        marginRight: '9px',
      },
      '& .MuiInput-underline:before': {
        display: 'none',
      },
      '& .MuiInputBase-input': {
        padding: '7px 7px',
      },
    },
  });
  const classes = useStyles();
  const [openDialogEditar, setOpenDialogEditar] = useState<boolean>(false);
  const [openDialogExcluir, setOpenDialogExcluir] = useState<boolean>(false);

  const { boletinsWTG, setBoletinsWTG } = useBoletimContext();

  const [rows, setRows] = useState<any[]>([]);
  const [linhasSelecionadas, setLinhasSelecionadas] = useState<any[]>([]);

  const inputDataInicial = useRef<TextFieldProps>(null);
  const inputDataFinal = useRef<TextFieldProps>(null);

  const [openMessageError, setOpenMessageError] = React.useState(false);

  const onReset = () => {
    setLinhasSelecionadas([]);
  };

  const onSend = () => {
    const temp = rows?.filter(row => linhasSelecionadas.includes(row.id));
    const arrTemp = [...boletinsWTG, ...temp];

        setBoletinsWTG(
      arrTemp.filter((v, i, a) => a.findIndex(t => t.id === v.id) === i),
      );
          onReset();
  };

  const onChangeDateNow = () => {
    const updateRows: any[] = rows.map(row => {
      if (linhasSelecionadas.includes(row?.id)) {
        row.startPrevBr = formatDate(new Date(), true);
        row.completionPrev = formatDate(new Date(), false);
        row.activityPlanId = null;
      }
      return rows;
    });
    setOpenDialogExcluir(false);
  };

  const onChangeDate = (datai, dataf) => {
    if (dayjs(datai).isAfter(dayjs(dataf))) {
      setOpenMessageError(true);
      return;
    }

    const updateRows: any[] = rows.map(row => {
      if (linhasSelecionadas.includes(row?.id)) {
        row.startPrevBr = dayjs(datai).format('DD/MM/YYYY HH:mm');
        row.completionPrev = dayjs(dataf).format('DD/MM/YYYY HH:mm');
      }
      return rows;
    });
    setOpenDialogEditar(false);
  };

  const onDeselecionarLinhas = () => {
    linhasSelecionadas.map(item => item.id);
  };

  useEffect(() => {
    // Criar um array com todos os IDs inteiros de 0 a 218999
    const idList = Array.from(Array(219000).keys());

    // Remover IDs que já foram usados
    resultDataPush.forEach(item => {
      const idIndex = idList.indexOf(item.id);
      if (idIndex !== -1) {
        idList.splice(idIndex, 1);
      }
    });

    // Criar uma nova linha para cada item, usando um ID exclusivo
    const tempRows = resultDataPush.map((item, j) => {
      const id =
        item.id !== undefined
          ? item.id
          : idList.splice(Math.floor(Math.random() * idList.length), 1)[0];

      return {
        id,
        tipo: toggleState,
        area: item.area,
        activityDescription: item.activityDescription,
        activityPlanId: item.activityPlanId || null,
        equipmentTag: item.equipmentTag,
        equipment: item.equipment,
        activity: item.activity,
        startPrevBr: dayjs(
          item.startReplanBr ? item.startReplanBr : item.startPrevBr,
        )
          .format('DD/MM/YYYY HH:mm')
          .toString(),
        completionPrev: dayjs(
          item.endReplanBr ? item.endReplanBr : item.endPrevBr,
        )
          .format('DD/MM/YYYY HH:mm')
          .toString(),
        utilization: item.utilization,
        outage: item.outage,
        providerName: item.providerName || item.executor,
        activityName: item.activityName,
        activitiesId: item.activitiesId,
        observationField: item.observationField,
        clusterId: item.clusterId,
        installationId: item.installationId,
        instalationId: item.instalationId,
        equipmentId: item.equipmentId,
        completionPercentage: 0,
        planNumber: item.planNumber,
        maintenance:
          item.maintenanceType === undefined
            ? item.maintenance
            : item.maintenanceType,
        durationPrev: dayjs(item.completionPrev, 'hour').diff(
          item.startReplanBr ? item.startReplanBr : item.startPrevBr,
          'hour',
        ),
      };
    });
    const sortedAsc = tempRows.sort(
      (objA, objB) =>
        new Date(
          dayjs(objA?.startPrevBr!, 'DD/MM/YYYY HH:mm').format(),
        ).getTime() -
        new Date(
          dayjs(objB?.startPrevBr!, 'DD/MM/YYYY HH:mm').format(),
        ).getTime(),
    );
    setRows(sortedAsc);
  }, [resultDataPush]);

  useEffect(() => {
    resultDataPush.pop();
    // rows.pop();
  }, [toggleState]);

  const columns: GridColDef[] = [
    {
      field: 'equipmentTag',
      headerName: toggleState,
      width: 70,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params: any) => (
        <Tooltip
          title={
            toggleState === 'BOP'
              ? params?.row?.equipment
              : params?.row?.equipmentTag
          }
        >
          <span>
            {toggleState === 'BOP'
              ? params?.row?.equipment
              : params?.row?.equipmentTag}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'activity',
      headerName: 'Atividade',
      resizable: true,
      flex: 2,
      width: 160,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params: any) => (
        <Tooltip title={params?.row?.activity}>
          <span>{params?.row?.activity}</span>
        </Tooltip>
      ),
    },
    {
      field: 'startPrevBr',
      headerName: 'Início',
      width: 130,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params: any) => (
        <Tooltip title={params?.row?.startPrevBr}>
          <span>
            {params?.row?.startReplanBr
              ? params?.row?.startReplanBr
              : params?.row?.startPrevBr}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'completionPrev',
      headerName: 'Final',
      width: 130,
      sortable: true,
      disableColumnMenu: true,
      editable: false,
      renderCell: (params: any) => (
        <Tooltip title={params?.row?.completionPrev}>
          <span>{params?.row?.completionPrev}</span>
        </Tooltip>
      ),
    },
  ];

  function padTo2Digits(num: number) {
    return num.toString().padStart(2, '0');
  }
  // eslint-disable-next-line prefer-template
  function formatDate(date: Date, isInicio: boolean) {
    let hora = '';
    const barra = '/';
    if (isInicio) {
      hora = '  08:00:00';
    } else {
      hora = '  17:00:00';
    }
    return (
      [
        padTo2Digits(date.getDate()),
        padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join(barra) + hora
    );
  }

  return (
    <>
     <SnackBarMessages
        type={'error'}
        message={'Término previsto não pode ser menor que o início previsto.'}
        open={openMessageError}
        handleClose={() => { setOpenMessageError(false); }}
        duration={5000}
      />
      <div className={classes.root}>
        <div className={classes.gridHeader}>
          <h2 className={classes.h2}>Planejamento diário</h2>
        </div>
        <Button
          variant="outlined"
          color="primary"
          className={`${classes.button} ${classes.singleButton}`}
          aria-label="outlined primary button"
          title="Adicionar ao Boletim"
          onClick={onSend}
        >
          Adicionar
        </Button>
        <ButtonGroup
          color="primary"
          aria-label="outlined primary button group"
          className={classes.buttonGroup}
        >
          <Button
            className={classes.button}
            title="Início"
            onClick={() => {
              setOpenDialogEditar(true);
            }}
            style={{ width: '120px', color: green[500] }}
          >
            <ScheduleIcon style={{ fontSize: '17px' }} />
            Editar
          </Button>
        </ButtonGroup>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => {
            setOpenDialogExcluir(true);
          }}
          className={`${classes.button} ${classes.singleButton}`}
          aria-label="outlined primary button"
          title="Remover atividade"
        >
          <DeleteOutlineOutlinedIcon />
        </Button>
      </div>

      <DataGrid
        className={classes.container}
        rows={rows}
        columns={columns}
        headerHeight={30}
        rowHeight={30}
        checkboxSelection
        getRowClassName={params => {
          return params.row.activityPlanId == null ? 'laranja' : '';
        }}
        autoHeight
        // hideFooter
        hideFooterSelectedRowCount
        experimentalFeatures={{ newEditingApi: true }}
        onSelectionModelChange={setLinhasSelecionadas}
        selectionModel={linhasSelecionadas}
        getRowId={row => row.id}
        disableSelectionOnClick
      />
      {isLoading && <Loading />}
      <Dialog
        open={openDialogEditar}
        onClose={() => {
          setOpenDialogEditar(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          id="form-dialog-title"
          style={{
            fontSize: 16,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          Selecione a data para ser alterada
        </DialogTitle>
        <DialogContent>
          <TextField
            id="txtDataInicial"
            label="Início"
            type="datetime-local"
            inputRef={inputDataInicial}
            defaultValue={dayjs().format('YYYY-MM-DDTHH:mm')}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            id="txtDataFinal"
            label="Final"
            inputRef={inputDataFinal}
            type="datetime-local"
            defaultValue={dayjs().format('YYYY-MM-DDTHH:mm')}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: `${inputDataInicial.current?.value}`, 
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialogEditar(false);
            }}
            color="secondary"
          >
            Cancelar
          </Button>
          <Button
            onClick={() => {
              setOpenDialogEditar(false);
              const linhasEscolhidas = linhasSelecionadas;
              const datai: any = inputDataInicial.current?.value;
              const dataf: any = inputDataFinal.current?.value;

              onChangeDate(datai, dataf);
              linhasEscolhidas.forEach(function (item) {
                setRows(
                  rows.map(function (grid) {
                    if (grid.id === item.id) {
                      const linhaEditada = item;
                      return linhaEditada;
                    }
                    return grid;
                  }),
                );
              });
            }}
            color="primary"
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDialogExcluir}
        onClose={() => {
          setOpenDialogExcluir(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" style={{ textAlign: 'center' }}>
          Confirma a exclusão das linhas selecionada(s)
        </DialogTitle>
        <DialogContent
          style={{
            fontSize: 16,
            color: '#000000b7',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          As atividades selecionadas serão excluídas (mantida em aberto/atraso)
          e novas atividades criadas, deseja prosseguir?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialogExcluir(false);
            }}
            color="secondary"
          >
            Cancelar
          </Button>
          <Button onClick={onChangeDateNow} color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewDailyBulletinPlanningGrid;
